import {createUpdateSlice} from "../genericCrudSlice";
import {updateMovementApi} from "../../api/entities/movements";

const updateMovementSlice = createUpdateSlice('movements', updateMovementApi);
export const {init: initUpdateMovement} = updateMovementSlice.actions;
export const {updateEntity: updateMovement} = updateMovementSlice;
export default updateMovementSlice.reducer;